<template>
  <div class="create-payment-page">
    <div class="create-payment">
      <div class="select-form-wrapper">
        <el-form
          :model="formData"
          label-position="left"
          :inline="false"
          label-width="140px"
          :rules="rules1"
          ref="formRef"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目部" prop="deptId">
                <el-select
                  :value="formData.deptId"
                  placeholder="请选择"
                  @change="deptChange"
                  clearable
                >
                  <el-option
                    v-for="dept in deptList"
                    :key="dept.applyDeptId"
                    :label="dept.applyDeptName"
                    :value="dept.applyDeptId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="projectId">
                <el-select
                  v-model="formData.projectId"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="project in projectList"
                    :key="project.projectId"
                    :label="project.name"
                    :value="project.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="付款申请日期" prop="payApplyDate">
                <el-date-picker
                  v-model="formData.payApplyDate"
                  type="date"
                  placeholder="请选择"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="付款明细日期" prop="payDetailDate">
                <el-date-picker
                  v-model="formData.payDetailDate"
                  type="date"
                  placeholder="请选择"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="main-wraper">
        <div class="form-wrapper">
          <div>
            <el-button type="primary" @click.stop="projectChange"
              >获取表格数据</el-button
            >
            <span>请填写选项后，点击按钮获取此处表格数据</span>
          </div>
        </div>
        <div class="table-wrapper">
          <el-table :data="tableList" border width="100%" height="450">
            <el-table-column label="序号" type="index" fixed></el-table-column>
            <el-table-column label="收款单位名称" prop="partyB" width="200" fixed></el-table-column>
            <el-table-column label="开户行" prop="bankName" width="200"></el-table-column>
            <el-table-column label="账户" prop="bankAccount" width="200"></el-table-column>
            <el-table-column label="本次审批付款额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.thisPay)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="支付方式">
              <el-table-column label="转账支票" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.checkAmount)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="网银" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.ebankAmount)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="商业承兑(纸质/电子)" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.tradeAcceptanceAmount)}}</div>
                </template>
              </el-table-column>
              <el-table-column label="银行承兑(纸质/电子)" width="100">
                <template slot-scope="scope">
                  <div>{{formatMoneyNumber(scope.row.bankAcceptanceAmount)}}</div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="当前已付款额" width="200">
              <template slot-scope="scope">
                <div>{{formatMoneyNumber(scope.row.alreadyPayAmount)}}</div>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" width="200"></el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="editRow(scope.row)"
                      >编辑</el-button
                    >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btns">
            <el-button type="primary" @click.stop="submitData">提交</el-button>
            <el-button type="info" @click.stop="cancelSubmit">取消</el-button>
          </div>
      </div>
    </div>
    
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="600px">
      <el-form :model="dialogData" label-width="160px" label-position="right">
        <el-form-item label="收款单位名称">
          <el-input
            :value="dialogData && dialogData.partyB ? dialogData.partyB : ''"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行">
          <el-input
            :value="
              dialogData && dialogData.bankName ? dialogData.bankName : ''
            "
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="账户">
          <el-input
            :value="
              dialogData && dialogData.bankAccount ? dialogData.bankAccount : ''
            "
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="本次审批付款额">
          <el-input
            :value="dialogData && dialogData.thisPay ? dialogData.thisPay : ''"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="转账支票">
          <el-input-number
            v-model="dialogData.checkAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="checkAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="网银">
          <el-input-number
            v-model="dialogData.ebankAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="ebankAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="商业承兑（纸质/电子）">
          <el-input-number
            v-model="dialogData.tradeAcceptanceAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="tradeAcceptanceAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="银行承兑（纸质/电子）">
          <el-input-number
            v-model="dialogData.bankAcceptanceAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="bankAcceptanceAmountHandler"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="当前已付款额">
          <!-- <el-input :value="formatMoneyNumber(dialogData.alreadyPayAmount)" disabled></el-input> -->
          <el-input-number
            v-model="dialogData.alreadyPayAmount"
            controls-position="right"
            clearable
            :precision="2"
            placeholder="请输入"
            disabled
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入"
            v-model="dialogData.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click.stop="confirmDialog">确定</el-button>
        <el-button type="info" @click.stop="cancelDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 付款明细-新建
 */
import Constants from "@/utils/consts";
import {
  getDeptList,
  getProjectList,
  queryEarningCostInfo,
  getPayDetailListDept,
  payDetailListProjectApi,
  addPayment
} from "../../services/financeService";
import { formatYMDstr } from "../../utils/index";
import { formatMoney } from "./utils";
export default {
  name: "CreatePayment",
  data() {
    return {
      formData: {
        deptId: undefined, //项目部id
        projectId: undefined, //项目id
        payApplyDate: undefined, //付款申请日期
        payDetailDate: undefined //付款明细日期
      },
      rules1: {
        deptId: [
          { required: true, message: "请选择项目部", trigger: "change" }
        ],
        projectId: [
          { required: true, message: "请选择项目名称", trigger: "change" }
        ],
        payApplyDate: [
          { required: true, message: "请选择付款申请日期", trigger: "change" }
        ]
      },
      deptList: [], // 可供选择的项目部
      projectList: [], // 可供选择的项目
      tableList: [], // 填的数据
      dialogVisible: false,
      dialogData: {}
    };
  },
  methods: {
    formatMoneyNumber: formatMoney,
    // formatMoneyNumber(params) {
    //   console.log('--format params', params)
    // },
    formatYMDstr,
    onActive() {
      this.getDeptListForSelect();
    },
    getDeptListForSelect() {
      getDeptList()
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.deptList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message, "提示");
        });
    },
    deptChange(value) {
      if (value != this.formData.deptId) {
        this.formData.deptId = value;
        // 项目部变了，那之前选择的就全部清空掉了
        this.formData.projectId = undefined;
        this.formData.payApplyDate = undefined;
        this.formData.payDetailDate = undefined;
        this.tableList = [];
        this.projectList = [];
        this.getProjectList();
      }
    },
    getProjectList() {
      getProjectList({ deptId: this.formData.deptId })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.projectList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message, "提示");
        });
    },
    /**
     * 选定了项目之后，要去获取对应的列表数据
     */
    projectChange() {
      this.$refs["formRef"].validate(valid => {
        if (!valid) {
          this.tableList = [];
          this.$alert("请先填写选项后再查询", "提示");
          return false;
        }
        let payDate = this.formatYMDstr(this.formData.payApplyDate);
        queryEarningCostInfo({
          payDate: payDate ? payDate : undefined, //用付款申请日期
          projectId: this.formData.projectId
        })
          .then(res => {
            if (res.code == Constants.Code_OK) {
              if (!res.data) {
                this.$alert("检索不到数据", "提示");
              }
              this.tableList = res.data || [];
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch(error => {
            this.$alert(error instanceof Error ? error.message : error, "提示");
          });
      });
    },
    editRow(item) {
      console.log("--editRow", item);
      this.editTargetItem = item;

      // let index = this.tableList.indexOf(item);
      // console.log('--index11', index);

      this.dialogData.partyB = item.partyB;
      this.dialogData.partyBId = item.partyBId;
      this.dialogData.bankName = item.bankName;
      this.dialogData.bankAccount = item.bankAccount;
      this.dialogData.thisPay = item.thisPay;
      this.$set(this.dialogData, 'checkAmount', item.checkAmount || 0);
      this.$set(this.dialogData, 'ebankAmount', item.ebankAmount || 0);
      this.$set(this.dialogData, 'tradeAcceptanceAmount', item.tradeAcceptanceAmount || 0);
      this.$set(this.dialogData, 'bankAcceptanceAmount', item.bankAcceptanceAmount || 0);
      this.$set(this.dialogData, 'alreadyPayAmount', item.alreadyPayAmount || 0);
      this.$set(this.dialogData, "remark", item.remark || "");
      this.dialogVisible = true;
    },
    confirmDialog() {
      // let index = this.tableList.indexOf(this.editTargetItem);
      // console.log('--index22', index);

      this.$set(this.editTargetItem, 'checkAmount', Number(this.dialogData.checkAmount || 0));
      this.$set(this.editTargetItem, 'ebankAmount', Number(this.dialogData.ebankAmount || 0));
      this.$set(this.editTargetItem, 'tradeAcceptanceAmount', Number(this.dialogData.tradeAcceptanceAmount || 0));
      this.$set(this.editTargetItem, 'bankAcceptanceAmount', Number(this.dialogData.bankAcceptanceAmount || 0));
      this.$set(this.editTargetItem, 'alreadyPayAmount', Number(this.dialogData.alreadyPayAmount || 0));
      this.$set(this.editTargetItem, 'remark', this.dialogData.remark);

      this.dialogData = {};
      this.dialogVisible = false;
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.dialogData = {};
    },
    submitData() {
      this.$confirm("确定要提交数据吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          let params = {};
          params.deptId = this.formData.deptId;
          params.projectId = this.formData.projectId;
          params.payApplyDate = this.formatYMDstr(this.formData.payApplyDate);
          params.payDetailDate = this.formatYMDstr(this.formData.payDetailDate);
          params.payDetailItemDtoList = this.tableList || [];
          params.payDetailItemDtoList.forEach(item => {
            item.payAmount = item.thisPay; // 后台接口字段不一致，这里转换一下
            item.vendorName = item.partyB; //收款单位名称
            item.cardNumber = item.bankAccount; //开户行账号
          });
          addPayment(params)
            .then(res => {
              if (res.code == Constants.Code_OK) {
                this.$alert("操作成功", "提示");
                this.bus.$emit("tabClose", "createPayment");
                this.bus.$emit("navMenuChange", {
                  routeId: "paymentList"
                });
              } else {
                this.$alert(res.msg, "提示");
              }
            })
            .catch(error => {
              this.$alert(
                error instanceof Error ? error.message : error,
                "提示"
              );
            });
        })
        .catch(() => {});
    },
    cancelSubmit() {
      this.$confirm("确定要取消新建吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          this.bus.$emit("tabClose", "createPayment");
          this.bus.$emit("navMenuChange", {
            routeId: "paymentList"
          });
        })
        .catch(() => {});
    },
    // 自动计算
    bankAcceptanceAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    tradeAcceptanceAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    ebankAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    checkAmountHandler() {
      this.updateAlreadyPayAmount();
    },
    updateAlreadyPayAmount() {
      
      let alreadyPayAmount  = Number(this.dialogData.checkAmount || 0) + Number(this.dialogData.ebankAmount || 0) + Number(this.dialogData.tradeAcceptanceAmount || 0) + Number(this.dialogData.bankAcceptanceAmount || 0);
      // this.dialogData.alreadyPayAmount = alreadyPayAmount;
      this.$set(this.dialogData, "alreadyPayAmount", alreadyPayAmount);
      console.log('--updateAlreadyPayAmount', alreadyPayAmount);
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "./table.scss";
@import "@/assets/css/commonLayout.scss";

.create-payment-page {
  background: white;
  position: relative;
}

.create-payment {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 16px 16px 0;
  overflow: auto;
}

.main-wraper {
  flex: 1;
}

.payment-footer {
  height: 60px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
}

/deep/.el-select {
  width: 100%;
}

/deep/.el-date-editor {
  width: 100%;
}

/deep/.el-input-number {
  width: 100%;
  text-align: left;
}

.btns {
  padding: 20px 0;
  text-align: center;
}
</style>
